import React, { useState } from "react";
import { Modal, Button,Input } from "antd";
import { useQueryClient } from "react-query";
import toast from "react-hot-toast";
import defaultAvatar from "../../../../assets/images/default-avatar.png";
import "../utils/validate.css";
import {rejetKycMerchent, updateKycStatus } from "../services/merchentApi";

const KycMerchentRejeter = ({ modal, setModal, toggle, selectedMerchent,onSuccess }) => {
  const queryClient = useQueryClient();
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
const isKycActive = selectedMerchent?.kycVerified;
const handleAction = async () => {
  if (!selectedMerchent?.id) {
    toast.error("Marchand invalide");
    return;
  }

  if (!reason.trim()) {
    toast.error("Le motif de rejet est obligatoire");
    return;
  }
  setIsLoadingSubmit(true);

  try {
    await rejetKycMerchent(
      selectedMerchent.id,
      false, // 
      reason
    );

    toast.success("KYC rejeté avec succès");

    if (onSuccess) {
      await onSuccess();
    }

    setModal(false);

  } catch (error) {
    const apiMessage = error?.response?.data?.message;
    toast.error(apiMessage || "Une erreur est survenue");
  } finally {
    setIsLoadingSubmit(false);
  }
};
const [reason, setReason] = useState("");
  return (
    <Modal
      open={modal}
      onCancel={toggle}
      footer={null}
      centered
     width={450}
      className="modal-validate"
    >
      <div className="validate-modal-content">
      <h2 className="validate-title">
      Rejeter le KYC du marchand
      </h2>
     <div>
      <div className="validate-merchent mb-3">
        <>
        <div>
          Le rejet du KYC entraînera la perte du statut vérifié du marchand sur la plateforme Paxity.
        </div>

        <div style={{ fontWeight: 500 }}>
          À compter de cette action :
        </div>

        <div>• Le marchand ne pourra plus recevoir de nouvelles commandes.</div>
        <div>• L’accès à certaines fonctionnalités de son compte sera restreint.</div>
        <div>• Son compte restera limité jusqu’à la validation de nouvelles informations conformes.</div>

        <div>
          Le marchand devra soumettre à nouveau ses documents KYC avec des informations valides afin de récupérer l’ensemble de ses fonctionnalités.
        </div>
      </>
</div>
<div style={{display: "flex",justifyContent: "center",alignItems: "center" }}>
                  <img
                    src={selectedMerchent?.profilePhoto ||defaultAvatar}
                       alt={`${selectedMerchent?.firstName} ${selectedMerchent?.lastName}`}
                        style={{
                            width: 46,
                            height: 46,
                            borderRadius: "50%",
                            objectFit: "cover"
                        }}
                        />
                  </div>
                    </div>
        < span className="merchent">{selectedMerchent?.firstName} {selectedMerchent?.lastName}</span>
        <div className="merchente">Marchand</div>
        <div className="validate-description">
            <>
              <p>
                Voulez-vous vraiment rejeter le KYC de ce marchand ?
              </p>
            </>
            <>
               <div style={{ marginTop: "15px" }}>
              <label style={{ fontWeight: 400 ,fontSize:'13px',fontFamily:'Poppins',color:'#6A6A6A',display:'flex',textAlign:'left'}}>Motif de rejet du kyc <span style={{color:"red"}}>*</span></label>
              <Input.TextArea
                placeholder="Message au marchand (sera envoyé par email)."
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                rows={4}
                style={{ marginTop: "6px", borderRadius: "8px",fontWeight: 400 ,fontSize:'13px',fontFamily:'Poppins',color:'#B7B7B7' }}
              />
            </div>
            </>
        </div>
  <div className="validate-footer mb-2">
        <button
        style={{
                  backgroundColor:" #FFF0F0",
                  color: " #D41C1C",
                  padding: "5px 12px",
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",
                  borderRadius: "8px",
                  border: "none",
                  outline: "none",
                  cursor: "pointer",
                  width:"80%"
                }}
            onClick={handleAction}
            loading={isLoadingSubmit}
          >
            {isLoadingSubmit ? "Rejet en cours..." : "Confirmer le rejet"}
          </button>
          </div>
           <button
           style={{
                  backgroundColor:'#F3F3F3',
                  color: '#000000',
                  padding: "5px 12px",
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",
                  borderRadius: "8px",
                  border: "none",
                  outline: "none",
                  cursor: "pointer",
                  width:"80%"
                }}
           onClick={() => setModal(false)} disabled={isLoadingSubmit}>
            Annuler
          </button>
      </div>
    </Modal>
  );
};

export default KycMerchentRejeter;
